/// <reference path="../htmleditor/htmleditor.ts" />
/// <reference path="../../crm/propertypicker/propertypicker.ts" />

namespace OfficeGuy.Apps {
    export class EmailSubscriptions {
        static InitMailingListEditor() {
            $(".og-emailsubscriptions-view .viewpicker, .og-emailsubscriptions-view .schemapicker").on("change", function () {
                var Schema = Teva.SelectBox.GetInstance($(".og-emailsubscriptions-view .schemapicker"));
                var View = Teva.SelectBox.GetInstance($(".og-emailsubscriptions-view .viewpicker"));
                Teva.SelectBox.GetInstance($(".og-emailsubscriptions-namefield .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
                Teva.SelectBox.GetInstance($(".og-emailsubscriptions-emailfield .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
                Teva.SelectBox.GetInstance($(".og-emailsubscriptions-namefield .viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
                Teva.SelectBox.GetInstance($(".og-emailsubscriptions-emailfield .viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
            });
        }
        static PropertyPicker() {
            var $Select_SchemaID = $('#SchemaID');
            if ($Select_SchemaID.val() == "" || $Select_SchemaID.val() == "0")
                return;
            var $Editor = $(this).closest(".sumit-field-value");
            CRM.PropertyPicker.ShowPropertyPicker($Select_SchemaID.val(), function (Path, Name, PathNames, PropertyValueType) {
                $("input[type=text]", $Editor).val(Name);
                $("input[type=hidden]", $Editor).val(Path);
            }, false, true);
        }

        static InitEditor(TemplateID: number = 0, MessageID: number = 0) {
            HTMLEditor.WidgetsDefinitions = EmailSubscriptions.ListWidgetsDefinitions();
            HTMLEditor.TemplateParameters = EmailSubscriptions.ListTemplateParameters();
            if (TemplateID == 0 && MessageID == 0)
                HTMLEditor.UploadImageURL = null;
            else
                HTMLEditor.UploadImageURL = "/emailsubscriptions/uploadimage/?templateid=" + TemplateID + "&messageid=" + MessageID;
            HTMLEditor.Function_CreateWidgetByName = EmailSubscriptions.CreateWidgetByName;
            HTMLEditor.IsEmailEditor = true;
            HTMLEditor.InitEditor();
        }

        static ListTemplateParameters() {
            var Parameters = new Array<HTMLEditor_Parameter>();
            //Parameters.push(new HTMLEditor_Parameter("", "כותרת ראשית", "HeaderText", "Text", "כותרת ראשית"));

            Parameters.push(new HTMLEditor_Parameter("כללי", "צבע רקע", "BackgroundColor", "BackgroundColor", "#FFFFFF"));
            Parameters.push(new HTMLEditor_Parameter("כללי", "גופן", "FontFamily", "FontFamily", "arial, helvetica, sans-serif"));
            Parameters.push(new HTMLEditor_Parameter("כללי", "שוליים", "Padding", "Padding", "10"));
            Parameters.push(new HTMLEditor_Parameter("כללי", "רוחב המייל", "BodyWidth", "Width", "700"));
            Parameters.push(new HTMLEditor_Parameter("כללי", "מיקום לרוחב", "BodyHorizontalAlign", "HorizontalAlign", "Right"));

            Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע רקע פנימי", "BodyInnerBackgroundColor", "BackgroundColor", "#FFFFFF"));
            Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע רקע", "BodyBackgroundColor", "BackgroundColor", "#FFFFFF"));
            Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע כתב", "BodyTextColor", "TextColor", "#212121"));
            Parameters.push(new HTMLEditor_Parameter("תוכן", "גודל כתב", "BodyTextSize", "TextSize", "16"));

            Parameters.push(new HTMLEditor_Parameter("פוטר", "צבע רקע", "FooterBackgroundColor", "BackgroundColor", "#FFFFFF"));
            Parameters.push(new HTMLEditor_Parameter("פוטר", "צבע כתב", "FooterTextColor", "TextColor", "#212121"));
            Parameters.push(new HTMLEditor_Parameter("פוטר", "גודל כתב", "FooterTextSize", "TextSize", "12"));

            return Parameters;
        }

        static ListWidgetsDefinitions() {
            var ToReturn = new Array<HTMLEditor_Widget>();
            ToReturn.push(EmailSubscriptions.CreateWidget_LogoHeader());
            ToReturn.push(EmailSubscriptions.CreateWidget_Header());
            ToReturn.push(EmailSubscriptions.CreateWidget_Image());
            ToReturn.push(EmailSubscriptions.CreateWidget_Logo());
            ToReturn.push(EmailSubscriptions.CreateWidget_Button());
            ToReturn.push(EmailSubscriptions.CreateWidget_ImageTitleTextButton());
            ToReturn.push(EmailSubscriptions.CreateWidget_Text());
            ToReturn.push(EmailSubscriptions.CreateWidget_TextImage());
            ToReturn.push(EmailSubscriptions.CreateWidget_ImageText());
            ToReturn.push(EmailSubscriptions.CreateWidget_TwoTextColumns());
            ToReturn.push(EmailSubscriptions.CreateWidget_ThreeTextColumns());
            ToReturn.push(EmailSubscriptions.CreateWidget_TwoImageColumns());
            ToReturn.push(EmailSubscriptions.CreateWidget_YouTube());
            ToReturn.push(EmailSubscriptions.CreateWidget_Social());
            ToReturn.push(EmailSubscriptions.CreateWidget_HTML());
            return ToReturn;
        }
        static CreateWidgetByName(Name): HTMLEditor_Widget {
            switch (Name) {
                case "LogoHeader":
                    return EmailSubscriptions.CreateWidget_LogoHeader();
                case "Header":
                    return EmailSubscriptions.CreateWidget_Header();
                case "Image":
                    return EmailSubscriptions.CreateWidget_Image();
                case "Logo":
                    return EmailSubscriptions.CreateWidget_Logo();
                case "Button":
                    return EmailSubscriptions.CreateWidget_Button();
                case "ImageTitleTextButton":
                    return EmailSubscriptions.CreateWidget_ImageTitleTextButton();
                case "Text":
                    return EmailSubscriptions.CreateWidget_Text();
                case "TextImage":
                    return EmailSubscriptions.CreateWidget_TextImage();
                case "ImageText":
                    return EmailSubscriptions.CreateWidget_ImageText();
                case "TwoTextColumns":
                    return EmailSubscriptions.CreateWidget_TwoTextColumns();
                case "TwoImageColumns":
                    return EmailSubscriptions.CreateWidget_TwoImageColumns();
                case "ThreeTextColumns":
                    return EmailSubscriptions.CreateWidget_ThreeTextColumns();
                case "YouTube":
                    return EmailSubscriptions.CreateWidget_YouTube();
                case "Social":
                    return EmailSubscriptions.CreateWidget_Social();
                case "HTML":
                    return EmailSubscriptions.CreateWidget_HTML();
                default:
                    alert("Invalid Widget Name: " + Name);
                    break;
            }
        }

        static CreateWidget_LogoHeader() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "LogoHeader";
            Widget.DisplayName = "לוגו וכותרת";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="BackgroundColor,' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" style="direction:rtl;">'
                + '<tr>'
                + '<td style="width:100%;padding:15px;">'
                + '<div style="font-size:20px;" og-email-parameter="Text,TextColor,FontFamily"></div>'
                + '</td>'
                + '<td style="padding-left:10px;">'
                + '<a target="_blank" rel="nofollow noreferrer" href="{CompanyURL}"><img class="og-email-header-logo" style="vertical-align:middle;max-height:40px;height:40px;max-width:initial;" src="{CompanyLogo}"></a>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", 'כותרת ראשית'));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גופן", "FontFamily", "FontFamilyWithDefault", ""));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_Header() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Header";
            Widget.DisplayName = "כותרת";
            Widget.Template = '<tr><td style="text-align:center;" og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '"><div og-email-parameter="Text,TextColor,FontFamily"></div></td></tr>'
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", '<h2 style="text-align:center;">כותרת משנית</h2>'));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גופן", "FontFamily", "FontFamilyWithDefault", ""));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_Image() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Image";
            Widget.DisplayName = "תמונה";
            Widget.Template = '<tr>'
                + '<td style="text-align:center;" og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="max-width:300px;max-height:225px;display:inline-block;margin-left:auto;margin-right:auto;" og-email-parameter="ImageWidth,ImageHeight"><a og-email-parameter="ImageHref"><img width="300" og-email-parameter="Image,AlternativeText,ImageWidth,ImageHeight" style="max-width:300px;max-height:225px;"></a></div>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תמונה", "Image", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/image.jpg"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט חלופי", "AlternativeText", "AlternativeText", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור", "ImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב תמונה מקסימלי", "ImageWidth", "ImageWidth", "300"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גובה תמונה מקסימלי", "ImageHeight", "ImageHeight", ""));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_Logo() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Logo";
            Widget.DisplayName = "לוגו";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + ',ImageHorizontalAlign">'
                + '<a target="_blank" rel="nofollow noreferrer" href="{CompanyURL}"><img og-email-parameter="ImageWidth,ImageHeight" class="og-email-header-logo" style="vertical-align:middle;initial;" src="{CompanyLogo}"></a>'
                + '</td>'
                + '</tr>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב תמונה מקסימלי", "ImageWidth", "ImageWidth", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גובה תמונה מקסימלי", "ImageHeight", "ImageHeight", "160"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מיקום התמונה", "ImageHorizontalAlign", "HorizontalAlign", "Center"));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }

        static CreateWidget_Button() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Button";
            Widget.DisplayName = "כפתור";
            Widget.Template = '<tr>'
                + '<td style="text-align:center;" og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table border="0" cellpadding="0" cellspacing="0" width="200" style="direction:rtl;border-collapse:separate;min-width:200px;max-width:100%;" align="center" og-email-template-parameter="FontFamily" class="og-email-button">'
                + '<tr>'
                + '<td align="center" width="200" og-email-parameter="ButtonBackgroundColor,ButtonBorderRadius" class="og-email-button" style="min-width:200px;max-width:100%;">'
                + '<a style="padding:10px;display:block;text-decoration:none;text-align:center;min-width:200px;max-width:100%;" og-email-parameter="Text,TextSize,TextColor,FontFamily,ButtonBackgroundColor,Href,ButtonBorderRadius" class="og-email-button">'
                + '</a>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט", "Text", "ButtonText", "לחץ/י כאן"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור", "Href", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע כתב לכפתור", "TextColor", "TextColor", "#0F243E"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע רקע לכפתור", "ButtonBackgroundColor", "ButtonBackgroundColor", "#C6D9F0"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רדיוס פינות מעוגלות", "ButtonBorderRadius", "BorderRadius", "4"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גודל כתב", "TextSize", "TextSize", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גופן", "FontFamily", "FontFamilyWithDefault", ""));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_ImageTitleTextButton() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "ImageTitleTextButton";
            Widget.DisplayName = "תמונה קטנה עם כותרת, טקסט וכפתור";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="160" align="center" class="og-email-mobile-block" og-email-parameter="ImageVerticalAlign">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="ImagePadding" style="text-align:center;">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="vertical-align:top;width:160px;max-height:130px;display:inline-block;"><a og-email-parameter="ImageHref"><img width="160" style="vertical-align:top;text-align:center;max-width:160px;max-height:150px;" og-email-parameter="Image,AlternativeText"></a></div>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="540" align="center" valign="top" class="og-email-mobile-block">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="TextPadding">'
                + '<div og-email-parameter="HeaderText,HeaderColor,HeaderSize,HeaderFontFamily"></div>'
                + '<div style="margin-top:9px;margin-bottom:9px;overflow:hidden;" og-email-parameter="Text,TextColor,TextFontFamily"></div>'
                + '<table border="0" cellpadding="0" cellspacing="0" width="200" style="direction:rtl;border-collapse:separate;min-width:200px;max-width:100%;" og-email-template-parameter="FontFamily" class="og-email-button" og-email-parameter="ButtonHorizontalAlign">'
                + '<tr>'
                + '<td align="center" width="200" og-email-parameter="ButtonBackgroundColor,ButtonBorderRadius" class="og-email-button" style="min-width:200px;max-width:100%;">'
                + '<a style="display:block;text-decoration:none;text-align:center;min-width:200px;max-width:100%;" og-email-parameter="ButtonText,ButtonSize,ButtonTextColor,ButtonFontFamily,ButtonBackgroundColor,Href,ButtonBorderRadius,ButtonPadding" class="og-email-button"></a>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();

            Widget.Parameters.push(new HTMLEditor_Parameter("כותרת", "צבע כתב", "HeaderColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("כותרת", "גודל כתב", "HeaderSize", "TextSize", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כותרת", "גופן", "HeaderFontFamily", "FontFamilyWithDefault", ""));

            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "כותרת", "HeaderText", "HTML", "כאן מזינים את הכותרת של התוכן!"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תוכן", "Text", "HTML", "ופה אפשר לספר, כל מיני דברים! דברים קצרים, ודברים ארוכים, בשורה אחת או ביותר! ואם תרצו, יש לכם גם כפתור שאת הטקסט והצבע שלו אפשר לערוך גם כן!"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "גופן", "TextFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "מרווח", "TextPadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "טקסט כפתור", "ButtonText", "ButtonText", "להמשך קריאה"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "קישור", "Href", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "צבע כתב", "ButtonTextColor", "TextColor", "#0F243E"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "צבע רקע", "ButtonBackgroundColor", "ButtonBackgroundColor", "#C6D9F0"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "גודל כתב", "ButtonSize", "TextSize", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "גופן", "ButtonFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "רדיוס פינות מעוגלות", "ButtonBorderRadius", "BorderRadius", "4"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "מיקום לרוחב", "ButtonHorizontalAlign", "HorizontalAlign", "right"));
            Widget.Parameters.push(new HTMLEditor_Parameter("כפתור", "מרווח", "ButtonPadding", "Padding", "10"));

            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "תמונה", "Image", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/imagetitletextbutton.jpg"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "טקסט חלופי", "AlternativeText", "AlternativeText", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "קישור", "ImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מיקום לגובה", "ImageVerticalAlign", "VerticalAlign", "top"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מרווח", "ImagePadding", "Padding", "18"));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");
            return Widget;
        }
        static CreateWidget_Text() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Text";
            Widget.DisplayName = "טקסט";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '"><div og-email-parameter="Text,TextColor,FontFamily"></div>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", 'זהו רכיב טקסט פשוט. רכיב בסיסי שמאפשר להכניס מלל קצר או ארוך, שהוא פעמים רבות מרכז התוכן של המסר שאתם מעבירים.<div>אפשר <b>להדגיש</b> דברים מסוימים, <u>בצורות שונות</u>.</div><div style="text-align: center;">למרכז את הטקסט</div><div style="text-align: right;">וגם להוסיף <a href="https://www.sumit.co.il">קישורים</a> בתוכו.</div></div>'));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גופן", "FontFamily", "FontFamilyWithDefault", ""));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_TextImage() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "TextImage";
            Widget.DisplayName = "טקסט ותמונה";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tbody class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="442" align="center" valign="top" class="og-email-mobile-block">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="Text,TextColor,TextFontFamily,TextPadding">'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="300" align="center" class="og-email-mobile-block" og-email-parameter="ImageVerticalAlign">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" style="text-align:center;" og-email-paremeter="ImagePadding">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="max-width:300px;max-height:225px;display:inline-block;vertical-align:top;margin-right:10px;"><a og-email-parameter="ImageHref"><img width="300" style="text-align:center;max-width:300px;max-height:225px;" og-email-parameter="Image"></a></div>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</tbody>'
                + '</table>'
                + '</td>'
                + '</tr>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", "כאן מזינים תוכן...<br />כאן מזינים תוכן...<br />כאן מזינים תוכן...<br />כאן מזינים תוכן..."));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תמונה", "Image", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/textimage.jpg"));

            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "קישור", "ImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מיקום לגובה", "ImageVerticalAlign", "VerticalAlign", "top"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מרווח", "ImagePadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "מרווח", "TextPadding", "Padding", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "גופן", "TextFontFamily", "FontFamilyWithDefault", ""));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");
            return Widget;
        }
        static CreateWidget_ImageText() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "ImageText";
            Widget.DisplayName = "תמונה וטקסט";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tbody class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="300" align="center" class="og-email-mobile-block" og-email-parameter="ImageVerticalAlign">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" style="text-align:center;" og-email-parameter="ImagePadding">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="max-width:300px;max-height:225px;display:inline-block;vertical-align:top;margin-right:10px;"><a og-email-parameter="ImageHref"><img width="300" style="text-align:center;max-width:300px;max-height:225px;" og-email-parameter="Image"></a></div>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="442" align="center" valign="top" class="og-email-mobile-block">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="Text,TextColor,TextFontFamily,TextPadding">'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</tbody>'
                + '</table>'
                + '</td>'
                + '</tr>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", "כאן מזינים תוכן...<br />כאן מזינים תוכן...<br />כאן מזינים תוכן...<br />כאן מזינים תוכן..."));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תמונה", "Image", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/textimage.jpg"));

            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "קישור", "ImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מיקום לגובה", "ImageVerticalAlign", "VerticalAlign", "top"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תמונה", "מרווח", "ImagePadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "מרווח", "TextPadding", "Padding", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "צבע כתב", "TextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("טקסט", "גופן", "TextFontFamily", "FontFamilyWithDefault", ""));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");
            return Widget;
        }
        static CreateWidget_TwoTextColumns() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "TwoTextColumns";
            Widget.DisplayName = "שתי עמודות טקסט";

            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="50%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="RightBackgroundColor,RightTextColor">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="RightText,RightPadding,RightFontFamily"></td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="50%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="LeftBackgroundColor,LeftTextColor">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="LeftText,LeftPadding,LeftFontFamily"></td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן עמודה ימנית", "RightText", "HTML", "זהו רכיב תוכן של שתי עמודות. אפשר להשתמש ברכיב זה כאשר רוצים לכתוב שני פנים של אותו הדבר, או על מנת לכתוב תוכן ארוך במיוחד."));
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן עמודה שמאלית", "LeftText", "HTML", "העמודות מופיעות זו לצד זו. אחת יכולה להיות ארוכה יותר מהשנייה."));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "צבע רקע", "RightBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "צבע כתב", "RightTextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "גופן", "RightFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "מרווח", "RightPadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "צבע רקע", "LeftBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "צבע כתב", "LeftTextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "גופן", "LeftFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "מרווח", "LeftPadding", "Padding", "18"));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");
            return Widget;
        }
        static CreateWidget_TwoImageColumns() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "TwoImageColumns";
            Widget.DisplayName = "שתי תמונות";

            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="50%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="RightBackgroundColor,RightImageVerticalAlign">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="RightPadding">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="max-width:300px;max-height:225px;display:inline-block;vertical-align:top;margin-right:10px;"><a og-email-parameter="RightImageHref"><img width="300" style="text-align:center;max-width:300px;max-height:225px;" og-email-parameter="RightImage"></a></div>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="50%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="LeftBackgroundColor,LeftImageVerticalAlign">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="LeftPadding">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="max-width:300px;max-height:225px;display:inline-block;vertical-align:top;margin-right:10px;"><a og-email-parameter="LeftImageHref"><img width="300" style="text-align:center;max-width:300px;max-height:225px;" og-email-parameter="LeftImage"></a></div>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "תמונה", "RightImage", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/textimage.jpg"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "קישור", "RightImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "מיקום לגובה", "RightImageVerticalAlign", "VerticalAlign", "top"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "צבע רקע", "RightBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "מרווח", "RightPadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "תמונה", "LeftImage", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/textimage.jpg"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "קישור", "LeftImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "מיקום לגובה", "LeftImageVerticalAlign", "VerticalAlign", "top"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "צבע רקע", "LeftBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "מרווח", "LeftPadding", "Padding", "18"));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");
            return Widget;
        }
        static CreateWidget_ThreeTextColumns() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "ThreeTextColumns";
            Widget.DisplayName = "שלוש עמודות טקסט";
            Widget.Template = '<div og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<div class="og-fullwidth" style="width:233px;display:inline-block;overflow:hidden;vertical-align:top;" og-email-parameter="RightBackgroundColor,RightTextColor"><div class="og-fullwidth" og-email-parameter="RightText,RightPadding"></div></div>'
                + '<div class="og-fullwidth" style="width:233px;display:inline-block;overflow:hidden;vertical-align:top;" og-email-parameter="MiddleBackgroundColor,MiddleTextColor"><div class="og-fullwidth" og-email-parameter="MiddleText,MiddlePadding"></div></div>'
                + '<div class="og-fullwidth" style="width:233px;display:inline-block;overflow:hidden;vertical-align:top;" og-email-parameter="LeftBackgroundColor,LeftTextColor"><div class="og-fullwidth" og-email-parameter="LeftText,LeftPadding"></div></div>'
                + '</div>';
            Widget.Template = '<tr>'
                + '<td og-email-parameter="BackgroundColor">'
                + '<table cellpadding="0" cellspacing="0" class="og-email-mobile-block">'
                + '<tr class="og-email-mobile-block">'
                + '<td width="33%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="RightBackgroundColor,RightTextColor">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="RightText,RightPadding,RightFontFamily"></td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="34%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="MiddleBackgroundColor,MiddleTextColor">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="MiddleText,MiddlePadding,MiddleFontFamily"></td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '<td width="33%" align="center" valign="top" class="og-email-mobile-block" og-email-parameter="LeftBackgroundColor,LeftTextColor">'
                + '<table border="0" cellpadding="10" cellspacing="0" width="100%" style="direction:rtl;" og-email-template-parameter="FontFamily">'
                + '<tr>'
                + '<td valign="top" og-email-parameter="LeftText,LeftPadding,LeftFontFamily"></td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>'
                + '</table>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן עמודה ימנית", "RightText", "HTML", "כאן אתם רואים רכיב תוכן של שלוש עמודות. יותר נוח להשתמש בו כאשר רוצים לכתוב שלושה דברים בעלי אורך דומה."));
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן עמודה אמצעית", "MiddleText", "HTML", "זה לא ממש אורך דומה."));
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן עמודה שמאלית", "LeftText", "HTML", "אבל כאן, אפשר ליצור תוכן דומה, למרות שבעצם כבר אמרנו את כל מה שיש לנו להגיד על הרכיב הזה, אז מה נכתוב עוד?"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "צבע רקע", "RightBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "צבע כתב", "RightTextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "גופן", "RightFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה ימנית", "מרווח", "RightPadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה אמצעית", "צבע רקע", "MiddleBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה אמצעית", "צבע כתב", "MiddleTextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה אמצעית", "גופן", "MiddleFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה אמצעית", "מרווח", "MiddlePadding", "Padding", "18"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "צבע רקע", "LeftBackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "צבע כתב", "LeftTextColor", "TextColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "גופן", "LeftFontFamily", "FontFamilyWithDefault", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עמודה שמאלית", "מרווח", "LeftPadding", "Padding", "18"));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget, "0");

            return Widget;
        }
        static CreateWidget_HTML() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "HTML";
            Widget.DisplayName = "קוד HTML";
            Widget.Template = '<tr>'
                + '<td og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '"><div og-email-parameter="HTML"></div>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("כללי", "תוכן HTML", "HTML", "CustomHTML", "<div style=\"padding:10px;\">כאן ניתן להזין קוד HTML משלכם. שימו לב, שימו ברכיב זה עלול לגרום לפגוע בתמיכה בתוכנות הדוא\"ל השונות.</div>"));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_YouTube() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "YouTube";
            Widget.DisplayName = "סרטון ב-YouTube";
            Widget.Template = '<tr>'
                + '<td style="text-align:center;" og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<a og-email-parameter="YouTubeVideoID"><img style="max-width:320px;width:100%;" width="320" og-email-parameter="YouTubeVideoID,AlternativeText"></a>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור/מזהה סרטון ב-YouTube", "YouTubeVideoID", "YouTubeVideoID", "yF47119Wcr8"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט חלופי", "AlternativeText", "AlternativeText", "לחצו כאן לצפיה בסרטון"));
            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }
        static CreateWidget_Social() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Social";
            Widget.DisplayName = "קישורים חברתיים";
            Widget.Template = '<tr>'
                + '<td style="text-align:center;" og-email-parameter="' + EmailSubscriptions.CommonParametersNames() + '">'
                + '<a og-email-parameter="WebsiteURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/website.png"></a>'
                + '<a og-email-parameter="FacebookURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/facebook.png"></a>'
                + '<a og-email-parameter="GooglePlusURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/googleplus.png"></a>'
                + '<a og-email-parameter="PinterestURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/pinterest.png"></a>'
                + '<a og-email-parameter="YouTubeURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/youtube.png"></a>'
                + '<a og-email-parameter="TwitterURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/twitter.png"></a>'
                + '<a og-email-parameter="LinkedInURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/linkedin.png"></a>'
                + '<a og-email-parameter="SkypeURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/skype.png"></a>'
                + '<a og-email-parameter="InstagramURL" style="padding-left:10px;padding-right:10px;"><img width="60" height="60" src="' + Common.FullRootURL + '/content/images/social/instagram.png"></a>'
                + '</td>'
                + '</tr>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "אתר אינטרנט", "WebsiteURL", "HrefHidden", "https://www.sumit.co.il"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Facebook", "FacebookURL", "HrefHidden", "https://www.facebook.com/SUMIT.co.il/"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Twitter", "TwitterURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "YouTube", "YouTubeURL", "HrefHidden", "https://www.youtube.com/channel/UC4tSTKkZVxcOMVSqpIJwJqQ"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Pinterest", "PinterestURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Google Plus", "GooglePlusURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "LinkedIn", "LinkedInURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Skype", "SkypeURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Instagram", "InstagramURL", "HrefHidden", ""));

            EmailSubscriptions.CreateWidget_CommonParameters(Widget);
            return Widget;
        }

        static CommonParametersNames() {
            return "BackgroundColor,Padding,BorderWidth,BorderColor";
        }

        static CreateWidget_CommonParameters(Widget, DefaultPadding = "18") {
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", DefaultPadding));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע רקע", "BackgroundColor", "BackgroundColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע מסגרת", "BorderColor", "BorderColor", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "עובי מסגרת", "BorderWidth", "BorderWidth", ""));
        }
    }
}
